import React from 'react';
import ReactPlayer from 'react-player';
import {useBreakpoint} from "../../libs/breakpoint";
//import Icon from "./Icon";
import _ from "lodash";

class PlayerContent extends React.Component {
    constructor(props) {
        super(props);
        let volume = _.toNumber(localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_volume`) || 0.5);
        let muted = this.props.muteStrength ? true : localStorage.getItem(`${process.env.REACT_APP_TOKEN_NAME}_muted`) === "true" ? true : false;
        this.state = {
            volume,
            muted
        }
        this.internalPlayer = null;
        this.onReady = this.onReady.bind(this);
    }


    shouldComponentUpdate(nextProps, nextState, nextContext) {
        if(this.props.preview !== nextProps.preview){
            return true;
        }
        return false;
    }

    componentWillUnmount() {
        try{
            if(this.internalPlayer){
                this.internalPlayer.removeEventListener('volumechange', this.onVolumeChange);
            }
        }catch (e){
            console.log(e);
        };

    }

    onReady = (player) => {
        try {
            this.internalPlayer = player.getInternalPlayer();
            this.internalPlayer.addEventListener('volumechange', this.onVolumeChange);
            this.props.setRefPlayer(this.internalPlayer);

        } catch (e) {
            console.log(e);
        }

    }


    onVolumeChange = (event) => {
        let {volume = 0.5, muted = false} = event.target;
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_volume`, volume);
        localStorage.setItem(`${process.env.REACT_APP_TOKEN_NAME}_muted`, muted);
        this.setState({ volume, muted });
    }


    render () {
        let {media = {}, playsinline = true, controls = true } = this.props;
        return (
            <ReactPlayer
                key={media._id}
                //id={media._id}
                playing={true}
                url={media.urlVideo}
                //light={media.preview}
                onReady={this.onReady}
                volume={this.state.volume}
                muted={this.state.muted}
                className='react-player'
                width='100%'
                height='100%'
                controls={controls}
                playsinline={playsinline}
                //playIcon={<Icon type="play" className={"big-player"} />}
                config={
                    {
                        file: {
                            attributes: {
                                controlsList: 'nodownload'
                            }
                        }
                    }
                }
            />
        )
    }
}

const Player = ({
        media = {},
        controls = true,
        playsinline = true,
        muteStrength = false,
        setRefPlayer = () =>{}
    }) => {
    const breakpoints = useBreakpoint();
    //let preview = (Array.isArray(media.screenshotsOrder) && !!media.screenshotsOrder.length) ? media.previewUrl[media.screenshotsOrder[0]] : media.previewUrl[0];
    let preview = media.videoCoverUrl;
    let {videoUrlFormat = {}} = media;
    
    let urlVideo = videoUrlFormat.hd;
    if(breakpoints.md ){
        urlVideo = videoUrlFormat.sd;
    }
//urlVideo = "http://www.rigarudy.com/hd.mp4";
    media = {
        ...media,
        preview,
        urlVideo
    }


    return <PlayerContent key={media._id} media={media} playsinline={playsinline} setRefPlayer={setRefPlayer} controls={controls} muteStrength={muteStrength} />;
}

export default Player;
